export const getApiBasePath = () => {
  const environment = getEnvironment();
  if(process.env.REACT_APP_SANDBOX === 'true') {
    return window.config && window.config.LFE_BFF_BASE_URL;
  }

  if(environment === 'dev') {
    return 'https://api.dev.troweprice.com/life-events/v1/';
  } else if(environment === 'stage') {
    return 'https://api.confidence.troweprice.com/life-events/v1/'
  }

  return 'https://api.public.troweprice.com/life-events/v1/'

};

export const getEnvironment = () => {
  if(window.location.host.includes('dev')) {
    return 'dev';
  } else if(window.location.host.includes('stage')) {
    return 'stage';
  }

  return 'production';
};

export const getExternalBasePath = () => {
  if(window.location.host.includes('dev')) {
    return 'https://wwwdev.troweprice.com';
  } else if(window.location.host.includes('stage')) {
    return 'https://wwwstage.troweprice.com';
  }

  return 'https://www.troweprice.com';
};
